// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SafariOverviewDetails_wrapper__nQcTY","item":"SafariOverviewDetails_item__2UzRq","mbNone":"SafariOverviewDetails_mbNone__20Ctf"};